import { render, staticRenderFns } from "./frequencyVisitChart.vue?vue&type=template&id=9d27d27e&scoped=true"
import script from "./frequencyVisitChart.vue?vue&type=script&lang=js"
export * from "./frequencyVisitChart.vue?vue&type=script&lang=js"
import style0 from "./frequencyVisitChart.vue?vue&type=style&index=0&id=9d27d27e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d27d27e",
  null
  
)

export default component.exports